module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av58-37c3616d6e9a6fbc73985f42791bf8f3.jpg";